import { render, staticRenderFns } from "./DDDIApplicationSaved.vue?vue&type=template&id=313a6846&"
import script from "./DDDIApplicationSaved.vue?vue&type=script&lang=js&"
export * from "./DDDIApplicationSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports